import {button, element} from './dom';

/** One label/state contract for the audience and its speaker controls. */
export class AudienceVisibility {
  readonly action = button('Hide audience', 'button button-quiet');
  readonly status = element('span', 'audience-status');

  constructor(toggle: () => void) {
    this.status.setAttribute('role', 'status');
    this.action.addEventListener('click', () => {
      toggle();
      const menu = this.action.closest('details');
      if (menu) {
        menu.open = false;
        menu.querySelector('summary')?.focus();
      }
    });
    this.sync(false);
  }

  sync(hidden: boolean): void {
    this.action.textContent = hidden ? 'Show audience' : 'Hide audience';
    this.action.ariaPressed = String(hidden);
    this.action.title = hidden ? 'Show the audience screen (B)' : 'Blank the audience screen; Speaker stays visible (B)';
    this.status.hidden = !hidden;
    this.status.textContent = hidden ? 'Audience hidden' : '';
  }
}
